// src/components/StorageImage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";

/**
 * Mostra un'immagine presa da Firebase Storage.
 * - Se hai path o immaginePath nel DB → lo usa.
 * - Se non c'è → costruisce il path da slug o dal titolo.
 */
export default function StorageImage({
  path,
  immaginePath,
  slug,
  titolo,
  tipo = "sezione",
  folderBase = "immagini",
  ext = "jpg",
  alt = "",
  width = 260,
  style,
}) {
  const [url, setUrl] = useState("");
  const [err, setErr] = useState("");

  // funzione per "slugificare" il titolo se manca slug
  const slugify = (s) =>
    String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");

 const effectivePaths = useMemo(() => {
  const paths = [];

  // 1. path esplicito
  if (path && path.trim()) {
    paths.push(path.trim());
    return paths;
  }

  // 2. immaginePath dal DB
  if (immaginePath && immaginePath.trim()) {
    if (immaginePath.includes("/")) {
      paths.push(immaginePath.trim());
    } else {
      paths.push(`${folderBase}/${tipo === "articolo" ? "articoli" : "sezioni"}/${immaginePath.trim()}.${ext}`);
    }
    return paths;
  }

  // 3. fallback con slug o titolo
  const baseName = slug && String(slug).trim()
    ? slug
    : titolo
    ? slugify(titolo)
    : "";

  if (!baseName) return [];

  // Prova PRIMA in cartella "sezioni" / "articoli"
  paths.push(`${folderBase}/${tipo === "articolo" ? "articoli" : "sezioni"}/${baseName}.${ext}`);
  // Poi prova anche nella cartella base (immagini/ direttamente)
  paths.push(`${folderBase}/${baseName}.${ext}`);

  return paths;
}, [path, immaginePath, slug, titolo, tipo, folderBase, ext]);


  useEffect(() => {
  let ignore = false;

  async function load() {
    if (!effectivePaths.length) {
      setUrl("");
      setErr("");
      return;
    }

    const storage = getStorage();

    for (const tryPath of effectivePaths) {
      try {
        const sRef = storageRef(storage, tryPath);
        const u = await getDownloadURL(sRef);
        if (!ignore) {
          setUrl(u);
          setErr("");
        }
        return; // fermati al primo valido
      } catch (e) {
        console.warn(`Immagine non trovata: ${tryPath}`);
      }
    }

    if (!ignore) {
      setUrl("");
      setErr("Immagine non disponibile");
    }
  }

  load();
  return () => {
    ignore = true;
  };
}, [effectivePaths]);


if (!effectivePaths.length) return null;

if (!url) {
  return (
    <div style={{ fontSize: 12, color: "#6b7280" }}>
      {err || "Caricamento immagine..."}
    </div>
  );
}

return (
  <img
    src={url}
    alt={alt}
    width={width}
    style={{ borderRadius: 6, display: "block", ...(style || {}) }}
    loading="lazy"
  />
);

}
